module.exports = __webpack_public_path__ + "assets/musux-alt.2e91ade9.svg";